import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/ology-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-606f02bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "sticky-top"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Logo",
  class: "company-logo"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "company-name m-0 mx-1" }, "Ology Newswire", -1))
const _hoisted_4 = {
  class: "px-2 ms-auto text-white bg-transparent border-0",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#learn-more"
}
const _hoisted_5 = {
  class: "px-2 text-white bg-transparent border-0",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#search-form"
}
const _hoisted_6 = {
  class: "px-2 text-white bg-transparent border-0",
  "data-bs-toggle": "offcanvas",
  "data-bs-target": "#offcanvas-menu",
  "aria-controls": "offcanvas-menu"
}
const _hoisted_7 = {
  key: 0,
  class: "alert alert-warning text-center",
  role: "alert",
  "data-mdb-color": "warning"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" An update is available: ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Update")

import SidebarNav from "@/components/SidebarNav.vue";
    import AlertModal from "@/components/AlertModal.vue";
    import {
        MDBNavbar,
        MDBIcon,
        MDBBtn
    } from "mdb-vue-ui-kit";
    import { ref } from "vue";

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const refreshing = ref(false);
    const registration = ref();
    const updateExists = ref(false);

    // Listen for our custom event from the SW registration
    document.addEventListener('swUpdated', updateAvailable, { once: true })

    // Prevent multiple refreshes
    navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (refreshing.value) return
        refreshing.value = true
        // Here the actual reload of the page occurs
        window.location.reload()
    });

    // Store the SW registration so we can send it a message
    // We use `updateExists` to control whatever alert, toast, dialog, etc we want to use
    // To alert the user there is an update they need to refresh for
    function updateAvailable(event) {
        registration.value = event.detail
        updateExists.value = true
    }

    // Called when the user accepts the update
    function refreshApp() {
        console.log('Refreshing App to update');
        updateExists.value = false
        // Make sure we only send a 'skip waiting' message if the SW is waiting
        if (!registration.value || !registration.value.waiting) return
        // send message to SW to skip the waiting and activate the new SW
        registration.value.waiting.postMessage({ type: 'SKIP_WAITING' })
    }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SidebarNav),
    _createVNode(AlertModal),
    (_ctx.$route.name !== 'Splash')
      ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
          _createVNode(_unref(MDBNavbar), {
            expand: "lg",
            dark: "",
            bg: "dark",
            container: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, {
                to: { name: 'Base Feed' },
                class: "navbar-brand align-items-center"
              }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _hoisted_3
                ]),
                _: 1
              }),
              _createElementVNode("button", _hoisted_4, [
                _createVNode(_unref(MDBIcon), {
                  icon: "question",
                  iconStyle: "fa",
                  size: "md"
                })
              ]),
              _createElementVNode("button", _hoisted_5, [
                _createVNode(_unref(MDBIcon), {
                  icon: "search",
                  iconStyle: "fa",
                  size: "md"
                })
              ]),
              _createElementVNode("button", _hoisted_6, [
                _createVNode(_unref(MDBIcon), {
                  icon: "bookmark",
                  iconStyle: "fa",
                  size: "md"
                })
              ])
            ]),
            _: 1
          }),
          (updateExists.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_unref(MDBBtn), {
                  color: "primary",
                  onClick: refreshApp
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ], 64))
}
}

})